/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(customStyle)] | transRpxStyle" class="es-card" v-if="(refactorList != null)"><slot name="title"/><div class="es-card__divider"></div><div class="es-card__tips" v-if="(tips != null && tips != '')">{{tips}}</div><div class="es-card__content"><div v-for="(item, index) in (refactorList)" :key="item.index"><div class="es-card__item"><div class="es-card__item-time"><es-icon :name="(item.iconName)" :color="(item.color)" size="18px"></es-icon><div class="es-card__item-line" v-if="(refactorList.length - 1 !=index)"></div></div><div class="es-card__item-right"><div :style="[(currentFilledIndex ===index ? 'color:#000000' : '')] | transRpxStyle" class="es-card__item-top">{{item.name || item.record_text}}</div><div class="es-card__item-bottom">{{item.value || item.record_time}}</div></div></div></div></div></div></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m7c1a2e22"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7c1a2e22"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex7c1a2e22%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex7c1a2e22%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7c1a2e22"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index7c1a2e22/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
